import { render } from "./OtiActionsOp.vue?vue&type=template&id=55b9ecee&scoped=true"
import script from "./OtiActionsOp.vue?vue&type=script&lang=js"
export * from "./OtiActionsOp.vue?vue&type=script&lang=js"

import "./OtiActionsOp.vue?vue&type=style&index=0&id=55b9ecee&lang=scss&scoped=true"

import exportComponent from "E:\\laragon\\www\\proyectos\\laravel\\sandy_laravel_vue\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b9ecee"]])

export default __exports__